// Func = limiting Scope for this file
(function(){

	function resizeWindow(){

	}
	function scrollDown(){
		let top = $(document).scrollTop();
		if (top > 0) {

		} else {

		}
	}

	$(document).ready(function () {

		document.querySelector('.burger').addEventListener('click', ()=>{
			document.querySelector('.container-menu').classList.add('active');
		});
		
		document.querySelector('.close-menu').addEventListener('click', ()=>{
			document.querySelector('.container-menu').classList.remove('active');
		});

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown();
		});
		
		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});
}());